<!-- Dashboard Container -->
<div class="min-h-screen bg-[#F5F7FA] p-2">
  <!-- Loading State -->
  <div *ngIf="isLoading" class="min-h-screen flex items-center justify-center bg-[#F5F7FA]">
    <div class="bg-white rounded-2xl px-12 py-10 flex flex-col items-center
            shadow-md">

      <!-- Spinner -->
      <div class="relative w-20 h-20 mb-6">
        <!-- Outer ring -->
        <div class="absolute inset-0 rounded-full border-4 border-[#FFE5DA]"></div>

        <!-- Animated ring -->
        <div class="absolute inset-0 rounded-full border-4
                border-[#FF5C02] border-t-transparent animate-spin"></div>

        <!-- Center dot -->
        <div class="absolute inset-0 flex items-center justify-center">
          <div class="w-3 h-3 rounded-full bg-[#FF5C02] animate-pulse"></div>
        </div>
      </div>

      <!-- Text -->
      <p class="text-[20px] font-bold text-[#2C3E50]">
        {{ t('dashboard.loading.title') }}
      </p>

      <span class="text-sm text-[#7F8C8D] mt-2 text-center">
        {{ t('dashboard.loading.subtitle') }}
      </span>
    </div>
  </div>

  <!-- Error State -->
  <div *ngIf="hasError && !isLoading" class="min-h-screen flex items-center justify-center bg-[#F5F7FA]">
    <div class="bg-white rounded-2xl px-10 py-8 max-w-md w-full text-center shadow-md">
      <!-- Icon -->
      <div class="w-16 h-16 mx-auto mb-4 flex items-center justify-center
              rounded-full bg-[#FFE5DA]">
        <svg class="w-8 h-8 text-[#FF5C02]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M12 9v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      </div>

      <!-- Title -->
      <h3 class="text-[20px] font-bold text-[#2C3E50] mb-2">
        {{ t('dashboard.error.title') }}
      </h3>

      <!-- Message -->
      <p class="text-[#7F8C8D] text-sm mb-6">
        {{ errorMessage }}
      </p>

      <!-- Action -->
      <button (click)="refreshDashboard()" class="px-6 py-2 rounded-xl
              bg-[#FF5C02] text-white font-semibold
              hover:bg-[#e14f02] transition">
        {{ t('dashboard.retry') }}
      </button>
    </div>
  </div>



  <!-- leyout principale -->
  <div *ngIf="!isLoading && !hasError">
    <!-- Header -->
    <div class="flex items-center justify-between mb-10">
      <!-- Title -->
      <h1 class="text-4xl font-bold text-[#2C3E50]">{{ t('dashboard.title') }}</h1>

      <!-- Right actions -->

      <div class="flex items-center gap-5">
        <!-- Search input -->
        <div class="relative w-[360px]">
          <span class="absolute inset-y-0 left-4 flex items-center text-[#777777]">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M21.7099 20.2899L17.9999 16.6099C19.44 14.8143 20.1374 12.5352 19.9487 10.2412C19.76 7.94721 18.6996 5.81269 16.9854 4.27655C15.2713 2.74041 13.0337 1.91941 10.7328 1.98237C8.43194 2.04534 6.24263 2.98747 4.61505 4.61505C2.98747 6.24263 2.04534 8.43194 1.98237 10.7328C1.91941 13.0337 2.74041 15.2713 4.27655 16.9854C5.81269 18.6996 7.94721 19.76 10.2412 19.9487C12.5352 20.1374 14.8143 19.44 16.6099 17.9999L20.2899 21.6799C20.3829 21.7736 20.4935 21.848 20.6153 21.8988C20.7372 21.9496 20.8679 21.9757 20.9999 21.9757C21.1319 21.9757 21.2626 21.9496 21.3845 21.8988C21.5063 21.848 21.6169 21.7736 21.7099 21.6799C21.8901 21.4934 21.9909 21.2442 21.9909 20.9849C21.9909 20.7256 21.8901 20.4764 21.7099 20.2899ZM10.9999 17.9999C9.61544 17.9999 8.26206 17.5894 7.11091 16.8202C5.95977 16.051 5.06256 14.9578 4.53275 13.6787C4.00293 12.3996 3.86431 10.9921 4.13441 9.63427C4.4045 8.27641 5.07119 7.02912 6.05016 6.05016C7.02912 5.07119 8.27641 4.4045 9.63427 4.13441C10.9921 3.86431 12.3996 4.00293 13.6787 4.53275C14.9578 5.06256 16.051 5.95977 16.8202 7.11091C17.5894 8.26206 17.9999 9.61544 17.9999 10.9999C17.9999 12.8564 17.2624 14.6369 15.9497 15.9497C14.6369 17.2624 12.8564 17.9999 10.9999 17.9999Z"
                fill="#777777" />
            </svg>
          </span>
          <input type="text" [placeholder]="t('dashboard.searchProject')"
            class="w-full h-[56px] pl-12 pr-4 text-[20px] text-[#777777] placeholder-[#777777] bg-white border border-gray-100 rounded-xl focus:outline-none focus:ring-0" />
        </div>

        <!-- Year selector -->
        <div
          class="font-semibold flex items-center justify-between h-[56px] px-7 bg-white border border-gray-100 rounded-xl cursor-pointer min-w-[180px]">
          <span class="text-[20px] font-medium text-[#333333]">
            {{ dashboardData.annee }}
          </span>
          <span class="text-[#777777] text-base">
            <svg width="16" height="9" viewBox="0 0 16 9" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L8 8L15 1" stroke="#777777" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </span>
        </div>
      </div>
    </div>

    <!-- LIGNE 1 -->
    <div class="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-10">
      <!-- Vue d'ensemble des chantiers -->
      <div class="bg-white rounded-xl p-5">
        <div class="flex items-center justify-between mb-5">
          <h2 class="text-[24px] font-bold text-[#2C3E50]">
            {{ t('dashboard.overview.sites') }}
          </h2>
          <span class="text-[#7F8C8D]">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path opacity="0.5"
                d="M9 8.5C9 8.76522 8.89464 9.01957 8.70711 9.20711C8.51957 9.39464 8.26522 9.5 8 9.5C7.73478 9.5 7.48043 9.39464 7.29289 9.20711C7.10536 9.01957 7 8.76522 7 8.5C7 8.23478 7.10536 7.98043 7.29289 7.79289C7.48043 7.60536 7.73478 7.5 8 7.5C8.26522 7.5 8.51957 7.60536 8.70711 7.79289C8.89464 7.98043 9 8.23478 9 8.5ZM6 13C6.26522 13 6.51957 12.8946 6.70711 12.7071C6.89464 12.5196 7 12.2652 7 12C7 11.7348 6.89464 11.4804 6.70711 11.2929C6.51957 11.1054 6.26522 11 6 11C5.73478 11 5.48043 11.1054 5.29289 11.2929C5.10536 11.4804 5 11.7348 5 12C5 12.2652 5.10536 12.5196 5.29289 12.7071C5.48043 12.8946 5.73478 13 6 13ZM18 13C18.2652 13 18.5196 12.8946 18.7071 12.7071C18.8946 12.5196 19 12.2652 19 12C19 11.7348 18.8946 11.4804 18.7071 11.2929C18.5196 11.1054 18.2652 11 18 11C17.7348 11 17.4804 11.1054 17.2929 11.2929C17.1054 11.4804 17 11.7348 17 12C17 12.2652 17.1054 12.5196 17.2929 12.7071C17.4804 12.8946 17.7348 13 18 13ZM16 9.5C16.2652 9.5 16.5196 9.39464 16.7071 9.20711C16.8946 9.01957 17 8.76522 17 8.5C17 8.23478 16.8946 7.98043 16.7071 7.79289C16.5196 7.60536 16.2652 7.5 16 7.5C15.7348 7.5 15.4804 7.60536 15.2929 7.79289C15.1054 7.98043 15 8.23478 15 8.5C15 8.76522 15.1054 9.01957 15.2929 9.20711C15.4804 9.39464 15.7348 9.5 16 9.5Z"
                fill="#777777" />
              <path
                d="M15.943 10.498L11.888 15.003C11.3777 15.0316 10.8978 15.2545 10.5467 15.6259C10.1956 15.9972 9.99996 16.4889 10 17H14C14 16.7333 13.9466 16.4693 13.8431 16.2236C13.7395 15.9778 13.5878 15.7553 13.397 15.569L17.057 11.502C17.1254 11.4293 17.1785 11.3436 17.2134 11.2501C17.2482 11.1566 17.264 11.057 17.2599 10.9573C17.2557 10.8575 17.2317 10.7596 17.1893 10.6693C17.1468 10.579 17.0868 10.498 17.0126 10.4312C16.9385 10.3644 16.8518 10.313 16.7575 10.2802C16.6633 10.2473 16.5634 10.2336 16.4638 10.2398C16.3642 10.246 16.2668 10.272 16.1774 10.3164C16.0879 10.3607 16.0083 10.4225 15.943 10.498ZM5 15.25C4.80109 15.25 4.61032 15.329 4.46967 15.4697C4.32902 15.6103 4.25 15.8011 4.25 16C4.25 16.1989 4.32902 16.3897 4.46967 16.5303C4.61032 16.671 4.80109 16.75 5 16.75H6.5C6.69891 16.75 6.88968 16.671 7.03033 16.5303C7.17098 16.3897 7.25 16.1989 7.25 16C7.25 15.8011 7.17098 15.6103 7.03033 15.4697C6.88968 15.329 6.69891 15.25 6.5 15.25H5ZM19.75 16C19.75 15.8011 19.671 15.6103 19.5303 15.4697C19.3897 15.329 19.1989 15.25 19 15.25H17.5C17.3011 15.25 17.1103 15.329 16.9697 15.4697C16.829 15.6103 16.75 15.8011 16.75 16C16.75 16.1989 16.829 16.3897 16.9697 16.5303C17.1103 16.671 17.3011 16.75 17.5 16.75H19C19.1989 16.75 19.3897 16.671 19.5303 16.5303C19.671 16.3897 19.75 16.1989 19.75 16ZM12.75 6C12.75 5.80109 12.671 5.61032 12.5303 5.46967C12.3897 5.32902 12.1989 5.25 12 5.25C11.8011 5.25 11.6103 5.32902 11.4697 5.46967C11.329 5.61032 11.25 5.80109 11.25 6V7.5C11.25 7.69891 11.329 7.88968 11.4697 8.03033C11.6103 8.17098 11.8011 8.25 12 8.25C12.1989 8.25 12.3897 8.17098 12.5303 8.03033C12.671 7.88968 12.75 7.69891 12.75 7.5V6Z"
                fill="#777777" />
              <path
                d="M12 3.25C6.063 3.25 1.25 8.063 1.25 14C1.25 15.498 1.557 16.927 2.112 18.224L2.117 18.236C2.332 18.738 2.48 19.084 2.934 19.568C3.117 19.763 3.373 19.958 3.611 20.116C3.849 20.273 4.13 20.431 4.381 20.523C5.005 20.75 5.549 20.75 6.318 20.75H17.682C18.451 20.75 18.995 20.75 19.619 20.523C19.871 20.431 20.151 20.273 20.389 20.116C20.627 19.959 20.883 19.763 21.066 19.568C21.52 19.084 21.669 18.738 21.883 18.236L21.888 18.224C22.443 16.927 22.75 15.498 22.75 14C22.75 8.063 17.937 3.25 12 3.25ZM2.75 14C2.75 11.5467 3.72455 9.19397 5.45926 7.45926C7.19397 5.72455 9.54675 4.75 12 4.75C14.4533 4.75 16.806 5.72455 18.5407 7.45926C20.2754 9.19397 21.25 11.5467 21.25 14C21.25 15.292 20.986 16.52 20.509 17.634C20.305 18.111 20.242 18.254 19.973 18.541C19.902 18.616 19.753 18.738 19.563 18.864C19.373 18.989 19.203 19.078 19.105 19.114C18.753 19.242 18.473 19.25 17.603 19.25H6.397C5.527 19.25 5.247 19.242 4.895 19.114C4.73434 19.0462 4.5809 18.9625 4.437 18.864C4.28984 18.7704 4.15249 18.6621 4.027 18.541C3.758 18.254 3.695 18.111 3.491 17.634C2.99987 16.4855 2.74775 15.2491 2.75 14Z"
                fill="#777777" />
            </svg>

          </span>
        </div>

        <div class="grid grid-cols-2 gap-4">
          <div class="bg-gray-50 rounded-lg px-4 py-3">
            <span class="text-[17px] font-medium text-[#7F8C8D]">{{ t('status.inProgress') }}</span>
            <p class="text-[30px] font-bold text-[#2C3E50] leading-tight">
              {{ dashboardData.chantiers.inProgress }}
            </p>
          </div>

          <div class="bg-gray-50 rounded-lg px-4 py-3">
            <span class="text-[17px] font-medium text-[#7F8C8D]">{{ t('status.delayed') }}</span>
            <p class="text-[30px] font-bold text-[#E74C3C] leading-tight">
              {{ dashboardData.chantiers.delayed }}
            </p>
          </div>

          <div class="bg-gray-50 rounded-lg px-4 py-3">
            <span class="text-[17px] font-medium text-[#7F8C8D]">{{ t('status.pending') }}</span>
            <p class="text-[30px] font-bold text-[#F39C12] leading-tight">
              {{ dashboardData.chantiers.pending }}
            </p>
          </div>

          <div class="bg-gray-50 rounded-lg px-4 py-3">
            <span class="text-[17px] font-medium text-[#7F8C8D]">{{ t('status.completed') }}</span>
            <p class="text-[30px] font-bold text-[#2ECC71] leading-tight">
              {{ dashboardData.chantiers.completed }}
            </p>
          </div>
        </div>
      </div>

      <!-- Vue d'ensemble des études -->
      <div class="bg-white rounded-xl p-5">
        <div class="flex items-center justify-between mb-5">
          <h2 class="text-[24px] font-bold text-[#2C3E50]">
            {{ t('dashboard.overview.studies') }}
          </h2>
          <span class="text-[#7F8C8D]">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path opacity="0.5"
                d="M9 8.5C9 8.76522 8.89464 9.01957 8.70711 9.20711C8.51957 9.39464 8.26522 9.5 8 9.5C7.73478 9.5 7.48043 9.39464 7.29289 9.20711C7.10536 9.01957 7 8.76522 7 8.5C7 8.23478 7.10536 7.98043 7.29289 7.79289C7.48043 7.60536 7.73478 7.5 8 7.5C8.26522 7.5 8.51957 7.60536 8.70711 7.79289C8.89464 7.98043 9 8.23478 9 8.5ZM6 13C6.26522 13 6.51957 12.8946 6.70711 12.7071C6.89464 12.5196 7 12.2652 7 12C7 11.7348 6.89464 11.4804 6.70711 11.2929C6.51957 11.1054 6.26522 11 6 11C5.73478 11 5.48043 11.1054 5.29289 11.2929C5.10536 11.4804 5 11.7348 5 12C5 12.2652 5.10536 12.5196 5.29289 12.7071C5.48043 12.8946 5.73478 13 6 13ZM18 13C18.2652 13 18.5196 12.8946 18.7071 12.7071C18.8946 12.5196 19 12.2652 19 12C19 11.7348 18.8946 11.4804 18.7071 11.2929C18.5196 11.1054 18.2652 11 18 11C17.7348 11 17.4804 11.1054 17.2929 11.2929C17.1054 11.4804 17 11.7348 17 12C17 12.2652 17.1054 12.5196 17.2929 12.7071C17.4804 12.8946 17.7348 13 18 13ZM16 9.5C16.2652 9.5 16.5196 9.39464 16.7071 9.20711C16.8946 9.01957 17 8.76522 17 8.5C17 8.23478 16.8946 7.98043 16.7071 7.79289C16.5196 7.60536 16.2652 7.5 16 7.5C15.7348 7.5 15.4804 7.60536 15.2929 7.79289C15.1054 7.98043 15 8.23478 15 8.5C15 8.76522 15.1054 9.01957 15.2929 9.20711C15.4804 9.39464 15.7348 9.5 16 9.5Z"
                fill="#777777" />
              <path
                d="M15.943 10.498L11.888 15.003C11.3777 15.0316 10.8978 15.2545 10.5467 15.6259C10.1956 15.9972 9.99996 16.4889 10 17H14C14 16.7333 13.9466 16.4693 13.8431 16.2236C13.7395 15.9778 13.5878 15.7553 13.397 15.569L17.057 11.502C17.1254 11.4293 17.1785 11.3436 17.2134 11.2501C17.2482 11.1566 17.264 11.057 17.2599 10.9573C17.2557 10.8575 17.2317 10.7596 17.1893 10.6693C17.1468 10.579 17.0868 10.498 17.0126 10.4312C16.9385 10.3644 16.8518 10.313 16.7575 10.2802C16.6633 10.2473 16.5634 10.2336 16.4638 10.2398C16.3642 10.246 16.2668 10.272 16.1774 10.3164C16.0879 10.3607 16.0083 10.4225 15.943 10.498ZM5 15.25C4.80109 15.25 4.61032 15.329 4.46967 15.4697C4.32902 15.6103 4.25 15.8011 4.25 16C4.25 16.1989 4.32902 16.3897 4.46967 16.5303C4.61032 16.671 4.80109 16.75 5 16.75H6.5C6.69891 16.75 6.88968 16.671 7.03033 16.5303C7.17098 16.3897 7.25 16.1989 7.25 16C7.25 15.8011 7.17098 15.6103 7.03033 15.4697C6.88968 15.329 6.69891 15.25 6.5 15.25H5ZM19.75 16C19.75 15.8011 19.671 15.6103 19.5303 15.4697C19.3897 15.329 19.1989 15.25 19 15.25H17.5C17.3011 15.25 17.1103 15.329 16.9697 15.4697C16.829 15.6103 16.75 15.8011 16.75 16C16.75 16.1989 16.829 16.3897 16.9697 16.5303C17.1103 16.671 17.3011 16.75 17.5 16.75H19C19.1989 16.75 19.3897 16.671 19.5303 16.5303C19.671 16.3897 19.75 16.1989 19.75 16ZM12.75 6C12.75 5.80109 12.671 5.61032 12.5303 5.46967C12.3897 5.32902 12.1989 5.25 12 5.25C11.8011 5.25 11.6103 5.32902 11.4697 5.46967C11.329 5.61032 11.25 5.80109 11.25 6V7.5C11.25 7.69891 11.329 7.88968 11.4697 8.03033C11.6103 8.17098 11.8011 8.25 12 8.25C12.1989 8.25 12.3897 8.17098 12.5303 8.03033C12.671 7.88968 12.75 7.69891 12.75 7.5V6Z"
                fill="#777777" />
              <path
                d="M12 3.25C6.063 3.25 1.25 8.063 1.25 14C1.25 15.498 1.557 16.927 2.112 18.224L2.117 18.236C2.332 18.738 2.48 19.084 2.934 19.568C3.117 19.763 3.373 19.958 3.611 20.116C3.849 20.273 4.13 20.431 4.381 20.523C5.005 20.75 5.549 20.75 6.318 20.75H17.682C18.451 20.75 18.995 20.75 19.619 20.523C19.871 20.431 20.151 20.273 20.389 20.116C20.627 19.959 20.883 19.763 21.066 19.568C21.52 19.084 21.669 18.738 21.883 18.236L21.888 18.224C22.443 16.927 22.75 15.498 22.75 14C22.75 8.063 17.937 3.25 12 3.25ZM2.75 14C2.75 11.5467 3.72455 9.19397 5.45926 7.45926C7.19397 5.72455 9.54675 4.75 12 4.75C14.4533 4.75 16.806 5.72455 18.5407 7.45926C20.2754 9.19397 21.25 11.5467 21.25 14C21.25 15.292 20.986 16.52 20.509 17.634C20.305 18.111 20.242 18.254 19.973 18.541C19.902 18.616 19.753 18.738 19.563 18.864C19.373 18.989 19.203 19.078 19.105 19.114C18.753 19.242 18.473 19.25 17.603 19.25H6.397C5.527 19.25 5.247 19.242 4.895 19.114C4.73434 19.0462 4.5809 18.9625 4.437 18.864C4.28984 18.7704 4.15249 18.6621 4.027 18.541C3.758 18.254 3.695 18.111 3.491 17.634C2.99987 16.4855 2.74775 15.2491 2.75 14Z"
                fill="#777777" />
            </svg>

          </span>
        </div>

        <div class="grid grid-cols-2 gap-4">
          <div class="bg-gray-50 rounded-lg px-4 py-3">
            <span class="text-[17px] font-medium text-[#7F8C8D]">{{ t('dashboard.studies.notInitiated') }}</span>
            <p class="text-[30px] font-bold text-[#2C3E50] leading-tight">
              {{ dashboardData.etudes.counts.PENDING }}
            </p>
          </div>

          <div class="bg-gray-50 rounded-lg px-4 py-3">
            <span class="text-[17px] font-medium text-[#7F8C8D]">{{ t('dashboard.studies.initiated') }}</span>
            <p class="text-[30px] font-bold text-[#F39C12] leading-tight">
              {{ dashboardData.etudes.counts.IN_PROGRESS }}
            </p>
          </div>

          <div class="bg-gray-50 rounded-lg px-4 py-3">
            <span class="text-[17px] font-medium text-[#7F8C8D]">{{ t('dashboard.metrics.delivered') }}</span>
            <p class="text-[30px] font-bold text-[#2C3E50] leading-tight">
              {{ dashboardData.etudes.counts.DELIVERED }}
            </p>
          </div>

          <div class="bg-gray-50 rounded-lg px-4 py-3">
            <span class="text-[17px] font-medium text-[#7F8C8D]">{{ t('dashboard.studies.completed') }}</span>
            <p class="text-[30px] font-bold text-[#3498DB] leading-tight">
              {{ dashboardData.etudes.counts.VALIDATED }}
            </p>
          </div>
        </div>
      </div>

      <!-- Répartition des études (%) -->
      <div class="bg-white rounded-xl p-5">
        <div class="flex items-center justify-between mb-4">
          <h2 class="text-[24px] font-semibold text-[#2C3E50]">
            {{ t('dashboard.studies.distribution') }}
          </h2>
          <span class="text-[#7F8C8D]">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M7.5 16.395H12V23.895H7.5V16.395ZM1.5 20.895H6V23.895H1.5V20.895ZM19.5 17.895H24V23.895H19.5V17.895ZM13.5 13.395H18V23.895H13.5V13.395ZM24 0L15.48 7.455L7.275 4.905L0 10.545V13.395L7.725 7.395L16.02 9.975L24 2.985V0Z"
                fill="#777777" />
            </svg>

          </span>
        </div>

        <div class="flex items-center gap-6">
          <div class="w-40 h-40 flex-shrink-0">
            <canvas #repartitionChart></canvas>
          </div>

          <div class="flex-1 space-y-4 text-sm">
            <div class="flex items-center justify-between">
              <div class="flex items-center gap-2">
                <span class="w-3 h-3 rounded-full bg-green-500"></span>
                <span class="text-[#7F8C8D]">{{ t('dashboard.studies.completed') }}</span>
              </div>
              <span class="font-semibold text-[#2C3E50]">
                {{ dashboardData.etudes.percentages.VALIDATED| number: '1.0-1' }}%
              </span>
            </div>

            <div class="flex items-center justify-between">
              <div class="flex items-center gap-2">
                <span class="w-3 h-3 rounded-full bg-orange-400"></span>
                <span class="text-[#7F8C8D]">{{ t('dashboard.studies.initiated') }}</span>
              </div>
              <span class="font-semibold text-[#2C3E50]">
                {{ dashboardData.etudes.percentages.IN_PROGRESS | number: '1.0-1' }}%
              </span>
            </div>

            <div class="flex items-center justify-between">
              <div class="flex items-center gap-2">
                <span class="w-3 h-3 rounded-full bg-blue-500"></span>
                <span class="text-[#7F8C8D]">{{ t('dashboard.metrics.delivered') }}</span>
              </div>
              <span class="font-semibold text-[#2C3E50]">
                {{ dashboardData.etudes.percentages.DELIVERED | number: '1.0-1' }}%
              </span>
            </div>

            <div class="flex items-center justify-between">
              <div class="flex items-center gap-2">
                <span class="w-3 h-3 rounded-full bg-red-500"></span>
                <span class="text-[#7F8C8D]">{{ t('dashboard.studies.notInitiated') }}</span>
              </div>
              <span class="font-semibold text-[#2C3E50]">
                {{ dashboardData.etudes.percentages.PENDING| number: '1.0-1' }}%
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>



    <!-- LIGNE 2 : Indicateurs clés -->
    <div class="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-10 items-stretch">

      <!-- Taux moyen d'avancement -->
      <div class="bg-white rounded-xl p-5 min-h-[340px] flex flex-col">

        <!-- Header -->
        <div class="flex items-center justify-between mb-5">
          <h2 class="text-[26px] font-bold text-[#2C3E50]">
            {{ t('dashboard.indicators.progress') }}
          </h2>
          <span class="text-[#7F8C8D]">

            <svg width="23" height="23" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M9 15H11V9H9V15ZM10 7C10.2833 7 10.521 6.904 10.713 6.712C10.905 6.52 11.0007 6.28267 11 6C10.9993 5.71733 10.9033 5.48 10.712 5.288C10.5207 5.096 10.2833 5 10 5C9.71667 5 9.47933 5.096 9.288 5.288C9.09667 5.48 9.00067 5.71733 9 6C8.99933 6.28267 9.09533 6.52033 9.288 6.713C9.48067 6.90567 9.718 7.00133 10 7ZM10 20C8.61667 20 7.31667 19.7373 6.1 19.212C4.88334 18.6867 3.825 17.9743 2.925 17.075C2.025 16.1757 1.31267 15.1173 0.788001 13.9C0.263335 12.6827 0.000667933 11.3827 1.26582e-06 10C-0.000665401 8.61733 0.262001 7.31733 0.788001 6.1C1.314 4.88267 2.02633 3.82433 2.925 2.925C3.82367 2.02567 4.882 1.31333 6.1 0.788C7.318 0.262667 8.618 0 10 0C11.382 0 12.682 0.262667 13.9 0.788C15.118 1.31333 16.1763 2.02567 17.075 2.925C17.9737 3.82433 18.6863 4.88267 19.213 6.1C19.7397 7.31733 20.002 8.61733 20 10C19.998 11.3827 19.7353 12.6827 19.212 13.9C18.6887 15.1173 17.9763 16.1757 17.075 17.075C16.1737 17.9743 15.1153 18.687 13.9 19.213C12.6847 19.739 11.3847 20.0013 10 20Z"
                fill="#777777" />
            </svg>

          </span>
        </div>

        <!-- Gauge -->
        <div class="flex-1 flex items-center justify-center">
          <div class="relative w-56 h-32">

            <svg viewBox="0 0 100 50" class="w-full h-full">
              <!-- Background -->
              <path d="M5,50 A45,45 0 0,1 95,50" fill="none" stroke="#EDF2F7" stroke-width="10"
                stroke-linecap="round" />

              <!-- Progress -->
              <path d="M5,50 A45,45 0 0,1 95,50" fill="none" stroke="#FF5C02" stroke-width="10" stroke-linecap="round"
                [attr.stroke-dasharray]="avancement.display.circumference"
                [attr.stroke-dashoffset]="avancement.display.dashOffset" />

              <!-- Point -->
              <circle [attr.cx]="avancement.display.pointX" [attr.cy]="avancement.display.pointY" r="6" fill="#FF5C02"
                stroke="#fff" stroke-width="3" />
            </svg>

            <!-- Center text -->
            <div class="absolute inset-0 flex flex-col items-center justify-center">
              <span class="text-[36px] font-bold text-[#2C3E50]">
                {{ avancement.pourcentage }}%
              </span>
              <span class="text-[14px] font-medium text-[#7F8C8D]">
                {{ t('dashboard.rate.avg') }}
              </span>
            </div>

          </div>
        </div>
      </div>


      <!-- Budget global -->
      <div class="bg-white rounded-xl p-5 min-h-[340px] flex flex-col">

        <!-- Header -->
        <div class="flex items-center justify-between mb-5">
          <h2 class="text-[26px] font-bold text-[#2C3E50]">
            {{ t('dashboard.indicators.budget') }}
          </h2>
          <span class="text-[#7F8C8D]">
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M13.5 16C13.5 16.3978 13.342 16.7794 13.0607 17.0607C12.7794 17.342 12.3978 17.5 12 17.5C11.6022 17.5 11.2206 17.342 10.9393 17.0607C10.658 16.7794 10.5 16.3978 10.5 16C10.5 15.6022 10.658 15.2206 10.9393 14.9393C11.2206 14.658 11.6022 14.5 12 14.5C12.3978 14.5 12.7794 14.658 13.0607 14.9393C13.342 15.2206 13.5 15.6022 13.5 16Z"
                fill="#777777" />
              <path
                d="M14.347 0.659912L17.527 5.11591L19.624 4.40091L21.538 9.99991H22.5V21.9999H1.5V9.99991H2.01V9.98991L2.658 9.99591L14.347 0.659912ZM9.397 9.99991H19.425L18.388 6.96691L16.866 7.45391L9.397 9.99991ZM7.839 8.41691L15.55 5.78991L13.946 3.53991L7.839 8.41691ZM5.5 11.9999H3.5V13.9999C4.03043 13.9999 4.53914 13.7892 4.91421 13.4141C5.28929 13.0391 5.5 12.5303 5.5 11.9999ZM15.5 15.9999C15.5 15.5403 15.4095 15.0852 15.2336 14.6605C15.0577 14.2359 14.7999 13.85 14.4749 13.525C14.1499 13.2 13.764 12.9422 13.3394 12.7663C12.9148 12.5904 12.4596 12.4999 12 12.4999C11.5404 12.4999 11.0852 12.5904 10.6606 12.7663C10.236 12.9422 9.85013 13.2 9.52513 13.525C9.20012 13.85 8.94231 14.2359 8.76642 14.6605C8.59053 15.0852 8.5 15.5403 8.5 15.9999C8.5 16.9282 8.86875 17.8184 9.52513 18.4748C10.1815 19.1312 11.0717 19.4999 12 19.4999C12.9283 19.4999 13.8185 19.1312 14.4749 18.4748C15.1313 17.8184 15.5 16.9282 15.5 15.9999ZM20.5 19.9999V17.9999C19.9696 17.9999 19.4609 18.2106 19.0858 18.5857C18.7107 18.9608 18.5 19.4695 18.5 19.9999H20.5ZM18.5 11.9999C18.5 12.5303 18.7107 13.0391 19.0858 13.4141C19.4609 13.7892 19.9696 13.9999 20.5 13.9999V11.9999H18.5ZM3.5 19.9999H5.5C5.5 19.4695 5.28929 18.9608 4.91421 18.5857C4.53914 18.2106 4.03043 17.9999 3.5 17.9999V19.9999Z"
                fill="#777777" />
            </svg>

          </span>
        </div>

        <!-- Content -->
        <div class="flex-1 flex items-center gap-6">

          <!-- Donut -->
          <div class="relative w-40 h-40 flex-shrink-0">
            <canvas #budgetChart class="w-full h-full"></canvas>

            <!-- Center text -->
            <div class="absolute inset-0 flex flex-col items-center justify-center">
              <span class="text-[26px] font-bold text-[#2C3E50]">
                {{ budget.pourcentageConsomme }}%
              </span>
              <span class="text-[14px] font-medium text-[#7F8C8D]">
                {{ t('dashboard.budget.consumed') }}
              </span>
            </div>
          </div>

          <!-- Legend -->
          <div class="flex-1 space-y-4 text-sm">

            <div class="flex items-center gap-3">
              <span class="w-2.5 h-2.5 rounded-full bg-[#FF5C02]"></span>
              <span class="text-[#34495E] font-medium">
                {{ t('dashboard.budget.consumed') }} :
              </span>
              <span class="font-bold text-[#2C3E50]">
                {{ formatCurrency(budget.consomme) }}
              </span>
            </div>

            <div class="flex items-center gap-3">
              <span class="w-2.5 h-2.5 rounded-full bg-gray-300"></span>
              <span class="text-[#34495E] font-medium">
                {{ t('dashboard.budget.remaining') }} :
              </span>
              <span class="font-bold text-[#2C3E50]">
                {{ formatCurrency(budget.restant) }}
              </span>
            </div>

          </div>
        </div>
      </div>


      <!-- Alertes stock matériaux -->
      <div class="bg-white rounded-xl p-5 min-h-[340px] flex flex-col">

        <!-- Header -->
        <div class="flex items-center justify-between mb-4">
          <div class="flex items-center gap-2">
            <span class="text-[#7F8C8D]">
            </span>
            <h2 class="text-[26px] font-bold text-[#2C3E50]">
              {{ t('dashboard.alerts.stock') }}
            </h2>
          </div>

          <span>

            <svg width="25" height="23" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M11.392 0.499956L20.918 17C21.0057 17.152 21.0519 17.3244 21.0519 17.5C21.052 17.6755 21.0057 17.8479 20.918 17.9999C20.8302 18.152 20.704 18.2782 20.552 18.366C20.4 18.4537 20.2275 18.5 20.052 18.5H0.999975C0.82444 18.5 0.651999 18.4537 0.499984 18.366C0.347968 18.2782 0.221734 18.152 0.133968 17.9999C0.0462029 17.8479 -1.11483e-06 17.6755 0 17.5C1.11487e-06 17.3244 0.0462074 17.152 0.133975 17L9.65997 0.499956C9.74775 0.347949 9.87398 0.221722 10.026 0.133962C10.178 0.0462015 10.3504 0 10.526 0C10.7015 0 10.8739 0.0462015 11.026 0.133962C11.178 0.221722 11.3042 0.347949 11.392 0.499956ZM9.52597 13.5V15.5H11.526V13.5H9.52597ZM9.52597 6.49996V11.5H11.526V6.49996H9.52597Z"
                fill="#777777" />
            </svg>

          </span>
        </div>

        <!-- Alerts list -->
        <div class="flex-1 overflow-y-auto space-y-5">

          <!-- ✅ Ajout du pipe slice pour afficher les 3 premières alertes -->
          <div *ngFor="let alerte of stockAlertes | slice:0:3" class="flex flex-col gap-1">
            <p class="font-medium text-[#34495E]">
              {{ alerte.nom }}
            </p>

            <div class="h-2 bg-gray-200 rounded-full overflow-hidden">
              <div class="h-full rounded-full transition-all" [style.width.%]="alerte.pourcentage"
                [class]="alerte.statusClass">
              </div>
            </div>

            <div class="flex justify-between text-sm">
              <span class="text-[#7F8C8D]">
                {{ alerte.quantiteActuelle }} {{ alerte.unite }} / seuil :
                {{ alerte.seuil }} {{ alerte.unite }}
              </span>

              <span class="font-medium" [class]="alerte.textClass">
                {{ alerte.status }}
              </span>
            </div>
          </div>

          <div *ngIf="stockAlertes.length === 0" class="text-center text-[#7F8C8D] text-sm">
            {{ t('dashboard.alerts.none') }}
          </div>
        </div>
      </div>

    </div>





    <!-- LIGNE 3: Graphiques (2 cards) -->
    <div class="dashboard-grid-special">

      <!-- État d'avancement -->
      <div class="dashboard-card">
        <div class="dashboard-card-header">
          <h2 class="text-[27px] font-bold text-gray-900">{{ t('dashboard.charts.progress') }}</h2>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
            class="text-gray-400 flex-shrink-0">
            <g clip-path="url(#clip0_3205_3606)">
              <path
                d="M7.5 16.5001H12V24.0001H7.5V16.5001ZM1.5 21.0001H6V24.0001H1.5V21.0001ZM19.5 18.0001H24V24.0001H19.5V18.0001ZM13.5 13.5001H18V24.0001H13.5V13.5001ZM24 0.105103L15.48 7.5601L7.275 5.0101L0 10.6501V13.5001L7.725 7.5001L16.02 10.0801L24 3.0901V0.105103Z"
                fill="currentColor" />
            </g>
            <defs>
              <clipPath id="clip0_3205_3606">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
        <div class="dashboard-card-content">
          <div class="h-56">
            <canvas #progressChart></canvas>
          </div>
        </div>
      </div>

      <!-- Incidents signalés (7 jours) -->
      <div class="dashboard-card">
        <div class="dashboard-card-header">
          <h2 class="text-[27px] font-bold text-gray-900">{{ t('dashboard.charts.incidents') }}</h2>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
            class="text-gray-400 flex-shrink-0">
            <path
              d="M12.8661 2.99996L22.3921 19.5C22.4799 19.652 22.5261 19.8244 22.5261 20C22.5261 20.1755 22.4799 20.3479 22.3921 20.4999C22.3043 20.652 22.1781 20.7782 22.0261 20.866C21.8741 20.9537 21.7016 21 21.5261 21H2.4741C2.29856 21 2.12612 20.9537 1.9741 20.866C1.82209 20.7782 1.69585 20.652 1.60809 20.4999C1.52032 20.3479 1.47412 20.1755 1.47412 20C1.47412 19.8244 1.52033 19.652 1.6081 19.5L11.1341 2.99996C11.2219 2.84795 11.3481 2.72172 11.5001 2.63396C11.6521 2.5462 11.8246 2.5 12.0001 2.5C12.1756 2.5 12.3481 2.5462 12.5001 2.63396C12.6521 2.72172 12.7783 2.84795 12.8661 2.99996ZM11.0001 16V18H13.0001V16H11.0001ZM11.0001 8.99996V14H13.0001V8.99996H11.0001Z"
              fill="currentColor" />
          </svg>
        </div>
        <div class="dashboard-card-content">
          <div class="h-56">
            <canvas #incidentsChart></canvas>
          </div>
        </div>
      </div>
    </div>
















    <!-- LIGNE 4 : Suivi & Performance -->
    <div class="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-10 items-stretch">

      <!-- Tâches critiques -->
      <div class="bg-white rounded-xl p-5 min-h-[340px] flex flex-col">
        <!-- Header -->
        <div class="flex items-center justify-between mb-4">
          <h2 class="text-[25px] font-bold text-[#2C3E50]">
            {{ t('dashboard.tasks.critical') }}
          </h2>
          <svg width="22" height="27" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M8.69395 1.83788H16.6939V3.83784H8.69395V1.83788ZM8.69395 8.83786H16.6939V10.8379H8.69395V8.83786ZM8.69395 15.8378H16.6939V17.8379H8.69395V15.8378ZM5.59148 0L6.78042 0.914531L3.21642 5.5478L0 2.73342L0.98775 1.60458L3.00187 3.36586L5.59148 0ZM5.59148 6.99998L6.78042 7.91456L3.21642 12.5478L0 9.73341L0.98775 8.60456L3.00187 10.3658L5.59148 6.99998ZM5.59148 14L6.78042 14.9145L3.21642 19.5478L0 16.7334L0.98775 15.6046L3.00187 17.3659L5.59148 14Z"
              fill="#777777" />
          </svg>

        </div>

        <!-- Content -->
        <div class="flex-1 overflow-y-auto space-y-4 pr-1">
          <div *ngFor="let tache of tachesCritiques" class="flex items-center gap-3">
            <span class="w-2.5 h-2.5 rounded-full" [ngClass]="{
             'bg-red-500': tache.status === 'En retard',
             'bg-orange-400': tache.status === 'Urgent',
             'bg-green-500': tache.status === 'À jour'
           }"></span>

            <div class="flex-1 min-w-0">
              <p class="text-sm font-semibold text-[#2C3E50] truncate">
                {{ tache.nom }}
              </p>
              <p class="text-xs text-[#7F8C8D]">
                Échéance : {{ tache.echeance }}
              </p>
            </div>

            <span class="px-3 py-1 rounded-full text-xs font-semibold whitespace-nowrap" [ngClass]="{
             'bg-red-100 text-red-700': tache.status === 'En retard',
             'bg-orange-100 text-orange-700': tache.status === 'Urgent',
             'bg-green-100 text-green-700': tache.status === 'À jour'
           }">
              {{ tache.status }}
            </span>
          </div>
        </div>
      </div>

      <!-- Photos récentes -->
      <div class="bg-white rounded-xl p-5 min-h-[340px] flex flex-col">
        <!-- Header -->
        <div class="flex items-center justify-between mb-4">
          <h2 class="text-[25px] font-bold text-[#2C3E50]">
            {{ t('dashboard.photos.recent') }}
          </h2>
          <svg width="26" height="24" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M4 2.25C4 1.65326 4.23705 1.08097 4.65901 0.65901C5.08097 0.237053 5.65326 0 6.25 0H15.25C15.8467 0 16.419 0.237053 16.841 0.65901C17.2629 1.08097 17.5 1.65326 17.5 2.25V11.25C17.5 11.8467 17.2629 12.419 16.841 12.841C16.419 13.2629 15.8467 13.5 15.25 13.5H13.5V15.25C13.5 15.8467 13.2629 16.419 12.841 16.841C12.419 17.2629 11.8467 17.5 11.25 17.5H2.25C1.65326 17.5 1.08097 17.2629 0.65901 16.841C0.237053 16.419 0 15.8467 0 15.25V6.25C0 5.65326 0.237053 5.08097 0.65901 4.65901C1.08097 4.23705 1.65326 4 2.25 4H4V2.25ZM12 6.25C12 6.05109 11.921 5.86032 11.7803 5.71967C11.6397 5.57902 11.4489 5.5 11.25 5.5H2.25C2.05109 5.5 1.86032 5.57902 1.71967 5.71967C1.57902 5.86032 1.5 6.05109 1.5 6.25V13.192L7.168 10.254C7.57959 10.0404 8.04711 9.95922 8.50661 10.0215C8.9661 10.0838 9.39513 10.2865 9.735 10.602L12 12.706V6.25ZM1.5 15.25C1.5 15.664 1.836 16 2.25 16H11.25C11.4489 16 11.6397 15.921 11.7803 15.7803C11.921 15.6397 12 15.4489 12 15.25V14.753L8.714 11.702C8.60088 11.5968 8.45805 11.5292 8.30501 11.5082C8.15198 11.4873 7.99622 11.5141 7.859 11.585L1.5 14.882V15.25ZM5.5 4H11.25C11.8467 4 12.419 4.23705 12.841 4.65901C13.2629 5.08097 13.5 5.65326 13.5 6.25V12H15.25C15.4489 12 15.6397 11.921 15.7803 11.7803C15.921 11.6397 16 11.4489 16 11.25V2.25C16 2.05109 15.921 1.86032 15.7803 1.71967C15.6397 1.57902 15.4489 1.5 15.25 1.5H6.25C6.05109 1.5 5.86032 1.57902 5.71967 1.71967C5.57902 1.86032 5.5 2.05109 5.5 2.25V4Z"
              fill="#777777" />
          </svg>

        </div>

        <!-- Grid photos -->
        <div class="flex-1 grid grid-cols-3 gap-3">
          <div *ngFor="let photo of photosRecentes | slice:0:6"
            class="group relative aspect-square rounded-lg overflow-hidden cursor-pointer"
            (click)="openPhotoModal(photo)">
            <img [src]="getBaseFile() + photo.src"
              class="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110" />

            <!-- Hover Overlay -->
            <div
              class="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-60 transition-all duration-300 flex items-center justify-center opacity-0 group-hover:opacity-100">
              <!-- Magnify Icon -->
              <svg
                class="w-10 h-10 text-white transform scale-75 group-hover:scale-100 transition-transform duration-300"
                fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v6m3-3H7"></path>
              </svg>
            </div>

            <div class="absolute bottom-2 left-2 bg-black bg-opacity-70
                  text-white text-xs px-2 py-1 rounded z-10">
              <div class="font-semibold truncate">
                {{ photo.phase || photo.alt }}
              </div>
              <div class="opacity-80">{{ photo.date }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- Résumé des performances -->
      <div class="bg-white rounded-xl p-5 min-h-[340px] flex flex-col">
        <!-- Header -->
        <div class="flex items-center justify-between mb-4">
          <h2 class="text-[25px] font-bold text-[#2C3E50]">
            {{ t('dashboard.performance.summary') }}
          </h2>
          <svg width="27" height="27" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M4.5 20.25C4.30189 20.2474 4.11263 20.1676 3.97253 20.0275C3.83244 19.8874 3.75259 19.6981 3.75 19.5V4.5C3.75 4.30109 3.82902 4.11032 3.96967 3.96967C4.11032 3.82902 4.30109 3.75 4.5 3.75C4.69891 3.75 4.88968 3.82902 5.03033 3.96967C5.17098 4.11032 5.25 4.30109 5.25 4.5V19.5C5.24741 19.6981 5.16756 19.8874 5.02747 20.0275C4.88737 20.1676 4.69811 20.2474 4.5 20.25Z"
              fill="#777777" />
            <path
              d="M19.5 20.25H4.5C4.30109 20.25 4.11032 20.171 3.96967 20.0303C3.82902 19.8896 3.75 19.6989 3.75 19.5C3.75 19.3011 3.82902 19.1103 3.96967 18.9696C4.11032 18.829 4.30109 18.75 4.5 18.75H19.5C19.6989 18.75 19.8897 18.829 20.0303 18.9696C20.171 19.1103 20.25 19.3011 20.25 19.5C20.25 19.6989 20.171 19.8896 20.0303 20.0303C19.8897 20.171 19.6989 20.25 19.5 20.25ZM14 14.75C13.9015 14.7504 13.8038 14.7312 13.7128 14.6934C13.6218 14.6557 13.5392 14.6001 13.47 14.53L11 12.06L8.53 14.53C8.38783 14.6624 8.19978 14.7346 8.00548 14.7311C7.81118 14.7277 7.62579 14.649 7.48838 14.5116C7.35097 14.3742 7.27225 14.1888 7.26883 13.9945C7.2654 13.8002 7.33752 13.6121 7.47 13.47L10.47 10.47C10.6106 10.3295 10.8012 10.2506 11 10.2506C11.1988 10.2506 11.3894 10.3295 11.53 10.47L14 12.94L17.47 9.46997C17.6122 9.33749 17.8002 9.26537 17.9945 9.26879C18.1888 9.27222 18.3742 9.35093 18.5116 9.48835C18.649 9.62576 18.7277 9.81115 18.7312 10.0054C18.7346 10.1997 18.6625 10.3878 18.53 10.53L14.53 14.53C14.4608 14.6001 14.3782 14.6557 14.2872 14.6934C14.1962 14.7312 14.0985 14.7504 14 14.75Z"
              fill="#777777" />
            <path
              d="M18.5 13.84C18.3019 13.8374 18.1126 13.7576 17.9725 13.6175C17.8324 13.4774 17.7526 13.2881 17.75 13.09V10.25H15C14.8011 10.25 14.6103 10.171 14.4697 10.0303C14.329 9.88968 14.25 9.69891 14.25 9.5C14.25 9.30109 14.329 9.11032 14.4697 8.96967C14.6103 8.82902 14.8011 8.75 15 8.75H18.5C18.6981 8.75259 18.8874 8.83244 19.0275 8.97253C19.1676 9.11263 19.2474 9.30189 19.25 9.5V13.09C19.2474 13.2881 19.1676 13.4774 19.0275 13.6175C18.8874 13.7576 18.6981 13.8374 18.5 13.84Z"
              fill="#777777" />
          </svg>

        </div>

        <!-- Metrics -->
        <div class="flex-1 grid grid-cols-2 grid-rows-3 gap-4">

          <!-- Taux moyen -->
          <div class="bg-[#F9FAFB] rounded-xl px-4 py-3 flex flex-col justify-center">
            <p class="text-xs text-[#7F8C8D] mb-1">
              {{ t('dashboard.indicators.progress') }}
            </p>
            <p class="text-[28px] font-bold text-[#2C3E50] leading-none">
              {{ performances.tauxAvancement }}%
            </p>
          </div>

          <!-- Budget consommé -->
          <div class="bg-[#F9FAFB] rounded-xl px-4 py-3 flex flex-col justify-center">
            <p class="text-xs text-[#7F8C8D] mb-1">
              {{ t('dashboard.metrics.budgetConsumed') }}
            </p>
            <p class="text-[28px] font-bold text-[#2C3E50] leading-none">
              {{ performances.budgetConsomme }}%
            </p>
          </div>

          <!-- Incidents -->
          <div class="bg-[#F9FAFB] rounded-xl px-4 py-3 flex flex-col justify-center">
            <p class="text-xs text-[#7F8C8D] mb-1">
              {{ t('dashboard.metrics.incidents7d') }}
            </p>
            <p class="text-[28px] font-bold text-[#2C3E50] leading-none">
              {{ performances.incidents }}
            </p>
          </div>

          <!-- Présence moyenne -->
          <div class="bg-[#F9FAFB] rounded-xl px-4 py-3 flex flex-col justify-center">
            <p class="text-xs text-[#7F8C8D] mb-1">
              {{ t('dashboard.performance.avgPresence') }}
            </p>
            <p class="text-[28px] font-bold text-[#2C3E50] leading-none">
              {{ performances.presenceMoyenne }}%
            </p>
          </div>

          <!-- Tâches en retard -->
          <div class="bg-[#F9FAFB] rounded-xl px-4 py-3 flex flex-col justify-center">
            <p class="text-xs text-[#7F8C8D] mb-1">
              {{ t('dashboard.performance.lateTasks') }}
            </p>
            <p class="text-[28px] font-bold text-[#2C3E50] leading-none">
              {{ performances.tachesRetard }}
            </p>
          </div>

          <!-- Matériaux en alerte -->
          <div class="bg-[#F9FAFB] rounded-xl px-4 py-3 flex flex-col justify-center">
            <p class="text-xs text-[#7F8C8D] mb-1">
              {{ t('dashboard.performance.alertMaterials') }}
            </p>
            <p class="text-[28px] font-bold text-[#2C3E50] leading-none">
              {{ performances.materiauxAlerte }}
            </p>
          </div>

        </div>


      </div>

    </div>



  </div>

















</div>

<!-- Photo Modal -->
<div *ngIf="selectedPhoto" class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-90"
  (click)="closePhotoModal()">

  <div class="relative max-w-7xl w-full h-full flex flex-col items-center justify-center"
    (click)="$event.stopPropagation()">

    <!-- Close Button -->
    <button (click)="closePhotoModal()"
      class="absolute top-4 right-4 text-white hover:text-gray-300 z-50 p-2 rounded-full hover:bg-white/10 transition-colors">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>

    <!-- Main Image -->
    <div class="relative w-full flex-1 flex items-center justify-center overflow-hidden min-h-0">
      <img [src]="getBaseFile() + selectedPhoto.src" class="max-h-full max-w-full object-contain rounded-lg shadow-2xl"
        [alt]="selectedPhoto.phase || 'Photo chantier'">

      <!-- Navigation Buttons -->
      <button *ngIf="selectedPhoto.images?.length > 1" (click)="previousImage()"
        class="absolute left-4 top-1/2 transform -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-3 rounded-full transition-colors backdrop-blur-sm">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
        </svg>
      </button>

      <button *ngIf="selectedPhoto.images?.length > 1" (click)="nextImage()"
        class="absolute right-4 top-1/2 transform -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-3 rounded-full transition-colors backdrop-blur-sm">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
        </svg>
      </button>
    </div>

    <!-- Caption / Info -->
    <div class="mt-4 text-white text-center">
      <h3 class="text-xl font-bold">{{ selectedPhoto.phase }}</h3>
      <p class="text-sm opacity-80">{{ selectedPhoto.date }}</p>
      <div class="mt-2 flex gap-2 justify-center overflow-x-auto pb-2" *ngIf="selectedPhoto.images?.length > 1">
        <!-- Thumbnails could go here -->
        <div *ngFor="let img of selectedPhoto.images; let i = index" (click)="selectImageIndex(i)"
          class="w-16 h-16 rounded overflow-hidden cursor-pointer border-2 transition-all"
          [class.border-orange-500]="i === currentImageIndex" [class.border-transparent]="i !== currentImageIndex">
          <img [src]="getBaseFile() + img" class="w-full h-full object-cover">
        </div>
      </div>
    </div>

  </div>
</div>